import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetRevenueGeneratedByUserReport } from "../services/reports.services";

const RevenueGeneratedByUserReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/revenuegeneratedbyUserreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/revenuegeneratedbyUserreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const BranchIDs = params?.BranchIDs;
  const filterSector = params?.filterSector;
  const DateType = params?.DateType;

  const loading = useAppSelector((state) => state.reports.loading);
  const RevenueGeneratedListForReport = useAppSelector(
    (state) => state.reports.RevenueGeneratedListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: filterSector !== "0" ? filterSector : "",
        BranchIDs: BranchIDs !== "0" ? BranchIDs : "",
        DateType: DateType !== "0" ? DateType : "",
      };
      dispatch(GetRevenueGeneratedByUserReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "RevenueGeneratedByUserReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "revenuegeneratedbyUserreport.xlsx");
  };

  // const handleEdit = (item: any) => {
  //   navigate("/RevenueGenerated/edit", {
  //     state: {
  //       RevenueGeneratedID: item?.ID,
  //       SectorID: item?.SectorID,
  //     },
  //   });
  // };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Revenue Generated By User Report{" "}
          <span style={{ fontSize: 15 }}>
            {RevenueGeneratedListForReport &&
              RevenueGeneratedListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            RevenueGeneratedListForReport &&
            RevenueGeneratedListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            RevenueGeneratedListForReport &&
            RevenueGeneratedListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {RevenueGeneratedListForReport &&
      RevenueGeneratedListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  User Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Bookings
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Revenue
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Average Booking Value
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Cancellations
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  ConversionRate
                </th>
              </tr>
            </thead>
            <tbody>
              {RevenueGeneratedListForReport &&
                RevenueGeneratedListForReport.length > 0 &&
                RevenueGeneratedListForReport?.map(
                  (RevenueGenerated: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      {/* <td
                        className="hoverableName text-center"
                        onClick={() => {
                          handleEdit(RevenueGenerated);
                        }}
                      >
                        {RevenueGenerated?.TourBookingNo || ""}
                      </td> */}
                      <td className="text-center">
                        {RevenueGenerated?.UserName || ""}
                      </td>
                      <td className="text-center">
                        {RevenueGenerated?.TotalBookings || ""}
                      </td>
                      <td className="text-end">
                        {RevenueGenerated?.TotalRevenue
                          ? formatIndianNumber(RevenueGenerated?.TotalRevenue)
                          : ""}
                      </td>
                      <td className="text-center">
                        {RevenueGenerated?.AverageBookingValue || ""}
                      </td>
                      <td className="text-center">
                        {RevenueGenerated?.Cancellations || ""}
                      </td>
                      <td className="text-center">
                        {RevenueGenerated?.ConversionRate || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default RevenueGeneratedByUserReportView;
